import _Abstract from "system/abstract"
import Module_ContactForm from "modules/contact-form-v2"

export default class Module_ContactFormBEv2 extends Module_ContactForm {

  constructor(el, options) {
    super(el, $.extend(true, {}, options), 'module')

    // var $ctaInputForm = this.$el.find(".cta-input-form");
    // if($ctaInputForm.length)
    // {
    //   new InputValidator($ctaInputForm[0], {"submit_button_selector":".cta-input-form--send-btn"});
    // }

    // this.initialise();
    this.clearInputFormFields();
    var userFormTemplate = document.getElementById("aspnetForm");

  }

//   initialise()
//   {
//     this.$el.find("[data-responsive-image]").addClass("-no-colour-loading-bg")

//     console.log("Contact Form Initialise");
//    this.initListeners();
//   }

//   initListeners()
//   {
//     $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list").on("click","li", (e) => this.onCustomTickListItemClicked(e));
//     $(".cta-input-form--send-btn").click((e) => this.onSendFormButtonClicked(e));
//   }

  onCustomTickListItemClicked(_event)
  {

    console.log("tick");
    // var bOneAtATime = $(_event.currentTarget).closest(".custom-tick-list.-one-at-a-time").length >= 0;
    var $li = $(_event.currentTarget);
    // if(bOneAtATime)
    // {
      //Since we're now only triggering one at a time, lets remove the ticked modifier class on all of the li elements
      $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list li").removeClass("-ticked");
    // }

    var nextStepUrl = $li.attr('data-next-url');

    var $nextBtn = this.$el.find('.cta-page--next-page-btn');

    if($li.hasClass("-ticked"))
    {
      $li.removeClass("-ticked");
    }
    else
    {
      $li.addClass("-ticked");
    }


    var bAtleastOneIsTicked = $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list > li.-ticked").length > 0;
    if(bAtleastOneIsTicked)
    {
      $(".cta-options-page .cta-page--next-page-btn").removeClass("-hide");
    }
    else
    {
      $(".cta-options-page .cta-page--next-page-btn").addClass("-hide");
    }

    $nextBtn.attr('href',nextStepUrl);

  }

onSendFormButtonClicked()
  {

    // Change checkbox value when checked
    var $signMeUp = $('input[name="subscribe"]')
    if($signMeUp.prop('checked'))
    {
      $('.js-form-stream-val').attr('value',1)
    } else {
      $('.js-form-stream-val').attr('value',0)
    }
    
  //   if(window.innerWidth >768 ) {
  //     var htmlLoader = "<div class='-loading -loader-wrapper'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
  //     $(".cta-input-form--send-btn").after(htmlLoader);
  //     $(".cta-input-form--send-btn").css('visibility', 'hidden');
  //   } else {
  //     var htmlLoader = "<div class='-loading -loader-wrapper -loading-inline'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
  //     $(".cta-input-form--send-btn").after(htmlLoader);
  //     $(".cta-input-form--send-btn").css('display', 'none');
  //  }

  var htmlLoader = "<div class='-loading -loader-wrapper'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
  $(".cta-input-sugarform--send-btn").after(htmlLoader);
  $(".cta-input-sugarform--send-btn").css('visibility', 'hidden');
   
    if(window.location.hostname === "furnware-static.uniondigital.co.nz" || window.location.hostname === "localhost")
    {
      // ! remove return
      //return;
    }

    $("#aspnetForm").attr('action', $(".cta-input-form").data("sugar-market-post-url"));
    
    $("#aspnetForm").unbind('submit').removeAttr('onsubmit');
    
    $("#aspnetForm").submit();

  }

  onFormErrorOccurred(e)
  {
    alert("An error occurred submitting the form, please try again");
    this.$el.find(".-loader-wrapper").remove();
    $(".cta-input-sugarform--send-btn").css('visibility', 'visible');
  }

  clearInputFormFields() {
    $('.js-clear-btn').click(function(){
        $('.c-label-input__fields').val('');
        $('.c-label-select__fields').prop('selectedIndex', 0).selectric('refresh');
        $('#donotbulkemail0').prop("checked", false);
        $('#SignMeUpForSomeRegularInspiration').prop("checked", false);
    });
  }
 
}



/** WEBPACK FOOTER **
 ** ./modules/contact-form-BE-v2.js
 **/